"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var codes_1 = require("./codes");
exports.default = (function (config) {
    var ws = new config.ws.client(config.ws.url);
    var listeners = {};
    ws.onmessage = function (event) {
        if (typeof event.data !== 'string') {
            return;
        }
        var message = JSON.parse(event.data);
        if (message.code !== codes_1.default.OK) {
            return;
        }
        listener(message.event).forEach(function (event) { return event(message); });
    };
    var listener = function (name) {
        if (!listeners[name]) {
            listeners[name] = [];
        }
        return listeners[name];
    };
    var status = function () {
        return ws.readyState;
    };
    var send = function (message) {
        if (ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify(__assign({ token: config.accessToken }, message)));
        }
        if (ws.readyState === WebSocket.CONNECTING) {
            ws.onopen = function () {
                ws.send(JSON.stringify(__assign({ token: config.accessToken }, message)));
            };
        }
    };
    var subscribe = function () {
        var events = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            events[_i] = arguments[_i];
        }
        var subscribeEvents = [];
        for (var _a = 0, events_1 = events; _a < events_1.length; _a++) {
            var e = events_1[_a];
            subscribeEvents.push({
                name: e.name,
                ids: e.ids,
            });
            registerEvent(e.name, e.listener);
        }
        send({
            action: 'subscribe',
            events: subscribeEvents,
        });
    };
    var registerEvent = function (name, event) {
        listener(name).push(event);
    };
    var unsubscribe = function () {
        var events = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            events[_i] = arguments[_i];
        }
        send({
            action: 'unsubscribe',
            events: events.map(function (event) { return ({ name: event }); }),
        });
        events.forEach(function (event) { return (listeners[event] = []); });
    };
    var refreshToken = function () {
        send({ action: 'refresh_token' });
    };
    var ping = function () {
        send({ action: 'ping' });
    };
    var close = function () {
        ws.close();
    };
    return {
        close: close,
        listener: listener,
        ping: ping,
        refreshToken: refreshToken,
        send: send,
        status: status,
        subscribe: subscribe,
        unsubscribe: unsubscribe,
    };
});
//# sourceMappingURL=index.js.map